import { app } from '../../app.module'
/**
 * 機能を複数選択するフォーム
 * attribute: {array} selected-val 選択された機能の制限種別
 */
class FunctionMultiFormComponentCtrl {
  private scope: ng.IScope
  private selectedVal: {}

  constructor($scope) {
    this.scope = $scope
  }

  /**
   * 選択されたイベントともに、イベントを送信する
   */
  public selectFunction() {
    this.scope.$emit('setFunctionAccessControl', this.selectedVal)
  }
}

app.component('functionMultiForm', {
  bindings: {
    selectedVal: '<',
  },
  template: require('./function-multi-form.pug')(),
  controller: FunctionMultiFormComponentCtrl,
})
